import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const SharedSettingsState = {
  features: null,
}

export const SharedSettingsActions = {
  getFeatures: async ({ commit, getters }, force = false) => {
    if (getters.features && !force) return Promise.resolve(getters.features)

    return axiosRequest.
      get('/site_settings/features').
      then(({ data }) => {
        commit('setFeatures', data)
        return data
      }).
      catch(handleError)
  },
}

export const SharedSettingsMutations = {
  setFeatures (state, features) { state.features = features },
}

export const SharedSettingsGetters = {
  features: state => state.features,
  permissionEnabled: state => state.features?.permissions?.enabled,
}
